<template>
  <div class="page_box flex jc_ctr">
    <el-pagination
      :layout="layout"
      :total="totalCount"
      :page-size="listData.pageSize"
      :current-page.sync="listData.currentPage"
      @current-change="pageIndexChange"
      @size-change="pageSizeChange"
      background
      :small="isSmall"
    />
    <!--  :hide-on-single-page="true" -->
  </div>
</template>

<script>
export default {
  props: {
    listData: {
      type: Object,
      default() {
        return {};
      },
    },
    layout: {
      type: String,
      default: "prev, pager, next",
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    totalCount() {
      let showMax = this.listData?.maxUseTotal || 0
      let realCount = this.listData?.total || 0;
      return showMax > realCount ? realCount : showMax;
    },
  },
  methods: {
    pageSizeChange(val) {
      if (this.listData.currentPage * val > this.listData.total) {
        this.listData.currentPage = 1
      }
      this.$emit('pageSizeChange', val)
    },
    pageIndexChange(p) {
      this.$emit("pageIndexChange", p)
    },
  },
}
</script>

<style lang="less" scoped>
.page_box {
  padding-top: 20px;

  /deep/.el-pager li.active {
    background-color: #1e3c63 !important;
    color: #fff !important;
  }
  /deep/.el-pagination.is-background .el-pager li {
    // border: 1px solid #e2e2e2;
    background: #f9f9f9;
    width: 44px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    border-radius: 8px;
    font-size: 14px;
    color: #7c8191;
    font-weight: bold;
  }
  /deep/.el-pagination.is-background .btn-next {
    background-color: transparent;
    // border: 1px solid #e2e2e2;
    width: 44px;
    height: 44px;
    line-height: 44px !important;
  }
  /deep/.el-pagination.is-background .btn-prev {
    background-color: transparent;
    // border: 1px solid #e2e2e2;
    width: 44px;
    height: 44px;
    line-height: 44px !important;
  }
  /deep/.el-pager li {
    font-weight: normal;
  }
  /deep/.el-pagination span{
    height: 44px;
    line-height: 44px;
  }
}
</style>